import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import VariableSalaryModalBase from "../VariableSalaryModalBase.vue";
import priceFormatter from "@/utility/priceFormatter";
import Absence from "../Absence.vue";
import FixedCalculationBasis from "./FixedCalculationBasis.vue";
import FixedCalculationEquaction from "./FixedCalculationEquaction.vue";
export default Vue.extend({
    props: {
        selectedDate: String,
        salaryRow: {},
        salaryRowDetails: {},
    },
    components: {
        VariableSalaryModalBase,
        FixedCalculationBasis,
        FixedCalculationEquaction,
        Absence,
    },
    filters: {
        numberToSek(number) {
            return priceFormatter.fromNumber(number).toStringSEK();
        },
    },
    computed: {
        ...mapGetters("variableSalaryModal", ["hoveredVariable"]),
        variableSalaryClass() {
            const base = ["math-text", "h1", "cursor-default"];
            if (this.hoveredVariable === "Variable salary") {
                base.push("hovered");
            }
            return base;
        },
    },
    methods: {
        ...mapActions("variableSalaryModal", ["setHoveredVariable"]),
        hoveredClass(target) {
            if (target === this.hoveredVariable) {
                return "hovered";
            }
        },
    },
});
